import { GetterTree } from 'vuex'
import { Tags } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Tags, RootState> = {
  getTags: state => {
    return state.filterTags.sort((a, b) => {
      const x = a.label.toUpperCase(),
        y = b.label.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  getPersonGroups: state => {
    return state.filterPersonGroups.sort((a, b) => {
      const x = a.label.toUpperCase(),
        y = b.label.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  getResponseError: state => {
    return state.responseError
  },
  getResponseMessage: state => {
    return state.responseMessage
  },
  getCurrentTag: state => {
    return state.currentTag
  },
  getCurrentThingsTagged: state => {
    const currentThingsTagged = state.currentThingsTagged.map(thingTagged => {
      return {
        label: Object.entries(thingTagged)[0][1],
        id: Object.entries(thingTagged)[0][0]
      }
    })
    return currentThingsTagged
  },
  getCurrentAgentsTagged: state => {
    const currentAgentsTagged = state.currentAgentsTagged.map(agentTagged => {
      return {
        label: Object.entries(agentTagged)[0][1],
        id: Object.entries(agentTagged)[0][0]
      }
    })
    return currentAgentsTagged
  },
  getCurrentPersonsTagged: state => {
    const currentPersonsTagged = state.currentPersonsTagged.map(
      personTagged => {
        return {
          label: Object.entries(personTagged)[0][1],
          id: Object.entries(personTagged)[0][0]
        }
      }
    )
    return currentPersonsTagged
  }
}
